//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class MakeUpCreditSummaryDisplayItem extends ItemBase {  // OBSOLETE - Use only for compatibility
    TeacherName: string | null = null;
    StudentName: string | null = null;
    MakeUpCredits: number = 0;

    constructor(initializer?: Partial<MakeUpCreditSummaryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MakeUpCreditSummaryDisplayItem";
}
